<template>
  <span class="flex shrink-0 items-center justify-center overflow-hidden rounded border border-gray-200 bg-white">
    <img v-if="src && !failed" :src="src" :alt="reference || ''" class="h-full w-full object-contain" loading="lazy" referrerpolicy="no-referrer" @error="failed = true" />
    <span v-else class="px-1 text-center text-xs text-gray-500">Photo indisponible</span>
  </span>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{ src?: string | null; reference?: string }>();
const failed = ref(false);
watch(() => props.src, () => { failed.value = false; });
</script>
